import { color } from 'asserts/styles/colors';
import { InputWrapper } from 'components/customer/Reference';
import DefaultInput from 'components/input/DefaultInput';
import styled from 'styled-components';

const NoticeSkeleton = () => {
  return (
    <Wrapper>
      <InputWrapper>
        <DefaultInput name="search" search height="middle" />
      </InputWrapper>
      <InnerWrppaer>
        {Array(8)
          .fill(null)
          .map((_, index) => (
            <DataWrapper key={index}>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div>
                <div></div>
                <div></div>
              </div>
            </DataWrapper>
          ))}
      </InnerWrppaer>
    </Wrapper>
  );
};

export default NoticeSkeleton;

const Wrapper = styled.div`
  padding-top: 48px;
`;

const DataWrapper = styled.div`
  display: flex;
  width: 435px;
  height: 280px;
  padding: 32px;
  flex-direction: column;
  gap: 12px;
  border-radius: 12px;
  border: 1px solid ${color.gray200};
  background: ${color.white};

  div {
    width: 64px;
    height: 24px;
    background: ${color.gray200};
    border-radius: 4px;
  }

  div:nth-child(2) {
    width: 371px;
  }

  div:nth-child(3) {
    width: 205px;
  }

  div:nth-child(4) {
    width: 120px;
  }

  div:last-of-type {
    display: flex;
    gap: 8px;
    width: 168px;
    height: 80px;
    background: ${color.white};

    & div {
      width: 80px;
      height: 80px;
      background: ${color.gray200};
      border-radius: 8px;
    }
  }
`;

const InnerWrppaer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 48px 20px;
`;
